import React from 'react';
import './Blogs.css';
import { FaLinkedin } from 'react-icons/fa';

const blogs = [
  {
    title: "The Art of Prompt Engineering: Crafting Effective Queries for AI",
    platform: "Linkedin",
    icon: <FaLinkedin />,
    link: "https://www.linkedin.com/pulse/art-prompt-engineering-crafting-effective-queries-ai-gourav-b-zfefc/?trackingId=ZmwiP4BsmbGJwsGLYCKAww%3D%3D",
    description: "Explore how prompt engineering enhances AI interactions by blending linguistics, cognitive science, and tech—making it a powerful tool for developers, creators, and businesses.",
  },
  {
    title: "Integrating Firebase as Your Database",
    platform: "Linkedin",
    icon: <FaLinkedin />,
    link: "https://www.linkedin.com/pulse/integrating-firebase-your-database-gourav-b-ro61c/?trackingId=0pExcUc%2F6D0MVSuFbS6s5A%3D%3D",
    description: "Learn how to use Firebase as a powerful backend to streamline real-time data, user management, and scalable architecture for your modern web apps.",
  },
  {
    title: "Introduction to Bootstrap: A Guide to Building Responsive Websites",
    platform: "Linkedin",
    icon: <FaLinkedin />,
    link: "https://www.linkedin.com/pulse/introduction-bootstrap-guide-building-responsive-websites-gourav-b-zlpkc/?trackingId=jOGLx5KJwXrSTUYFe9iBdw%3D%3D",
    description: "A beginner-friendly guide to using Bootstrap for building responsive, mobile-first websites with ease using pre-built components and a flexible grid system.",
  },
  {
    title: "Unlocking the Power of Tailwind CSS: A Modern Approach to Web Styling",
    platform: "Linkedin",
    icon: <FaLinkedin />,
    link: "https://www.linkedin.com/pulse/unlocking-power-tailwind-css-modern-approach-web-styling-gourav-b-qn3kc/?trackingId=1khRHq0DQkvPfYrUuBj4rg%3D%3D",
    description: "Discover how Tailwind CSS simplifies modern web styling with utility-first classes that boost productivity and flexibility in frontend development.",
  },
];


const Blogs: React.FC = () => {
  return (
    <div className="blogs-container">
      <h2 className="blogs-title">✍️ My Blog Posts</h2>
      <p className="blogs-intro">A collection of my thoughts and tutorials on software development.</p>
      <div className="blogs-grid">
        {blogs.map((blog, index) => (
          <a href={blog.link} key={index} target="_blank" rel="noopener noreferrer" className="blog-card" style={{ '--delay': `${index * 0.2}s` } as React.CSSProperties}>
            <div className="blog-icon animated-icon">{blog.icon}</div>
            <div className="blog-info animated-text">
              <h3 className="blog-title">{blog.title}</h3>
              <p className="blog-description">{blog.description}</p>
              <span className="blog-platform">{blog.platform}</span>
            </div>
          </a>
        ))}
      </div>
    </div>
  );
};

export default Blogs;
